import { AnalyticsEventFragment } from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const getRewardsTopCategories = gql`
  query GetRewardsTopCategories($sortTopCategoryBy: SortBy) {
    myPartnerOffers {
      topCategories(sortBy: $sortTopCategoryBy) {
        id
        name
        iconUrl
        iconKey
        onClick {
          __typename
          route
          analyticsEvent {
            ...AnalyticsEventFragment
          }
        }
      }
    }
  }
  ${AnalyticsEventFragment}
`;

export default getRewardsTopCategories;
